// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__3S5yE","consent":"style_consent__2Bouj","buttons":"style_buttons__1Hoeh"};